import { render } from "./phone-bar.vue?vue&type=template&id=76623738&scoped=true"
import script from "./phone-bar.vue?vue&type=script&lang=js"
export * from "./phone-bar.vue?vue&type=script&lang=js"

import "./phone-bar.vue?vue&type=style&index=0&id=76623738&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76623738"]])

export default __exports__